/* eslint-disable react/prop-types */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import './paymentPopup.scss';
import CloseIcon from '../../../asset/images/close_icon.svg';
//import TickIcon from '../../../asset/images/circled_tick_black.svg';
import TickIcon from '../../../asset/images/paymentIcon.svg';

class PaymentPopup extends Component {
  constructor (props) {
    super(props);
    this.state = {
      mobileNumber : ''
    };
  }

  render () {
    const { t } = this.props;
    return (
      <div className='overlay'>
        <div className='payment_popup_container'>
          <div className='inner_wrapper'>
            <div className='close_icon'
              onClick={() => {
                this.props.close();
              }}>
              <img src={CloseIcon} />
            </div>
            <div className='title_area'>
              <div className='icon'>
                <img src={TickIcon} />
              </div>
              <div className='title'>
                {t('almost_there')}
              </div>
            </div>
            <div className='content_area'>
              <div className='txt'>{t(this.props.cardDescribtion)} </div>
              <div className='error'>{t((this.props.cardError))}</div>
              <div className='input_area'>
                <div className='lbl'>{t(this.props.buttonHeader)}</div>
                {/* consider two-input holders and server side handling for phone and email */}
                <input type='text'
                  placeholder={this.props.placeholderValue ? this.props.placeholderValue : t('input_text')}
                  value={this.props.value}
                  onChange={(e) => {
                    this.props.validations(e);
                    this.setState({
                      mobileNumber: e.target.value
                    });
                  }} />
              </div>
              <div className='btn_wrapper'>
                <div className='visava-btn'
                  onClick={() => {
                    this.props.formOpen(this.state.mobileNumber);
                  }}>
                  {/* {t(this.props.buttonLabel)} */}
                  {t('proceed_payment')}
                </div>
              </div>
              <div className='note'>{t('no_further_edit')}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(PaymentPopup));